import React from "react";

const START_YEAR = 2025;

const YearNavigator = ({ year, setYear }) => {
    const CURRENT_YEAR = new Date().getFullYear();

    const btnClassName =
        "w-[30px] h-[30px] text-[18px] text-[#0af] font-black bg-[#181f2e] border-none rounded-full shadow-md cursor-pointer transition-colors duration-200";

    const placeholderClassName =
        "w-[30px] h-[30px] rounded-full invisible";

    const canGoPrev = year > START_YEAR;
    const canGoNext = year < CURRENT_YEAR;

    return (
        <div className="w-full flex justify-center items-center gap-[18px] text-white">
            {/* Previous Button */}
            {canGoPrev ? (
                <button
                    className={btnClassName}
                    title="العام السابق"
                    onClick={() => setYear(year - 1)}
                >
                    &#8592;
                </button>
            ) : (
                <div className={placeholderClassName} />
            )}

            {/* Year */}
            <span className="min-w-[80px] text-[15px] text-center font-bold tracking-[1px]">
                {year}
            </span>

            {/* Next Button */}
            {canGoNext ? (
                <button
                    className={btnClassName}
                    title="العام التالي"
                    onClick={() => setYear(year + 1)}
                >
                    &#8594;
                </button>
            ) : (
                <div className={placeholderClassName} />
            )}
        </div>
    );
};

export default YearNavigator;